import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import MyTheme from '../../../assets/theme/MyTheme';

const useStyles = makeStyles((theme: Theme) => ({
    overlay: {
        display: 'block',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255,255,255,0.5)',
        zIndex: MyTheme.zIndex.loading
    },
    spinner: {
        position: 'absolute',
        left: '50%',
        top: '50%'
    }
}));

const LoadingPage: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.overlay}>
            <CircularProgress className={classes.spinner}></CircularProgress>
        </div>
    );
}

export default LoadingPage;
